(function(app, ng) {

    app.filter("hideConnected",
        function() {
            return function (input, doHide) {
                if (!doHide) return input;
                var out = [];

                ng.forEach(input,
                    function(row) {
                        if (!row.AccountId) out.push(row);
                    });

                return out;
            }
        });

})(window.app, window.angular); //jshint ignore:line